class PrerenderService {
    private readonly isBot: boolean;
    private conditions: Array<Promise<any>> = [];
    private conditionsTimeout = -1;

    constructor() {
        this.isBot = /Prerender/i.test(navigator.userAgent);
    }

    waitFor(...conditions: Array<Promise<any>>) {
        if (!this.isBot) {
            return;
        }

        this.conditions.push(...conditions);
        clearTimeout(this.conditionsTimeout);
        this.conditionsTimeout = window.setTimeout(() => {
            Promise.all(this.conditions).then(setPrerenderReady);
        }, 500);
    }
}

export function setPrerenderReady() {
    // allow half sec for rendering
    setTimeout(() => {
        window.prerenderReady = true;
    }, 500);
}

export const prerender = new PrerenderService();
